import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Card, CardBody, Col, Container, Progress, Row } from "reactstrap";
import Geofences from "../../Catalogs/Geofences/Geofences";
import PointGeo from "./PointGeo";
import PointUnit from "./PointUnit";
import _ from "lodash";
import dayjs from "dayjs";

const RamalStatus = ({ branch, salidas }) => {
  const [status, setStatus] = useState({
    salidas_activas: 0,
    salidas_time: 0,
    salidas_over: 0,
  });
  const [geofences, setGeofences] = useState([
    {
      id: 1,
      name: "1 Nombre alias",
      percent: 0,
    },
    {
      id: 1,
      name: "2 Nombre alias",
      percent: 100,
    },
  ]);

  const [units, setUnits] = useState([
    {
      id: 1,
      number: "25",
      percent: 10,
    },
    {
      id: 1,
      number: "33",
      percent: 20,
    },
    {
      id: 1,
      number: "78",
      percent: 50,
    },
  ]);

  useEffect(() => {
    let geos = branch.geofences
      .filter((e) => e.percent != null);

    geos = geos.map((e, idx) => {
      return { id: e.id, name: e.geo?.alias, percent: e.percent, is_base: e.is_base || geos.length == idx + 1};
    });
    setGeofences(geos);
  }, [branch]);

  useEffect(() => {
    setStatus({
      salidas_activas: salidas.length,
      salidas_time: salidas.filter((e) => {
        return e.min_quemados == 0;
      }).length,
      salidas_over: salidas.filter((e) => {
        return e.min_quemados > 0;
      }).length,
    });

    let units = salidas?.map((e, idx) => {
      return {
        id: e.id,
        number: e.unit.number,
        percent: e.unit.percent ?? 0,
        last_time: dayjs(e.ultimo_tiempo).format("HH:mm"),
        time: e.unit.time,
        fpos: e.unit.final_position,
        quemados: e.min_quemados,
        byGeo: e.unit.byGeo,
        dst: e.unit.distance,
        //closest: e.unit.closest,
      };
    });
    setUnits(_.sortBy(units, ["percent"]));
  }, [salidas]);

  return (
    <React.Fragment>
      <Row>
        <Col md="4">
          <h4 className="card-title mb-4">Ramal | {branch?.name ?? "-"}</h4>
        </Col>
        <Col md="3">
          <div>
            <p className="mb-2">
              <small>
                <strong>Salidas Activas:</strong>{" "}
                {status.salidas_activas ?? "-"}
              </small>
            </p>
          </div>
        </Col>
        <Col md="5">
          <div>
            <p className="mb-2">
              <small>
                <i className="mdi mdi-circle align-middle font-size-10 me-1 text-success"></i>{" "}
                <strong>Unidades en tiempo:</strong>{" "}
                {status.salidas_time ?? "-"}
              </small>

              <small className="ms-5">
                <i className="mdi mdi-circle align-middle font-size-10 me text-warning"></i>{" "} 
                <i className="mdi mdi-circle align-middle font-size-10 me-2 text-danger"></i>{" "}
                <strong>Unidades quemadas:</strong> {status.salidas_over ?? "-"}
              </small>
            </p>
          </div>
        </Col>
        <Col md="3">
          
        </Col>
      </Row>

      <div className="table-responsive p-2">
        <div className="position-relative" style={{ minHeight: "120px" }}>
          <Progress
            animated={false}
            value={100}
            color="secondary"
            style={{ height: "4px" }}
          ></Progress>
          {(units || []).map((unit, index) => (
            <PointUnit unit={unit} key={index} />
          ))}
          {geofences.map((geo, index) => (
            <PointGeo geo={geo} key={index} />
          ))}
        </div>
        {
          //JSON.stringify(units)
        }
        {
          //JSON.stringify(geofences)
        }
      </div>
    </React.Fragment>
  );
};
export default RamalStatus;
